import { useFetch } from '@reveni-io/reveni-ui'

import commonServices from '@/common/services/services'

const useStoreProductCollections = ({ storeId, doInitialRequest }) => {
  const { data: productCollections, loading: fetchingProductCollections } = useFetch(
    () => commonServices.getStoreProductCollections({ storeId }),
    {
      doInitialRequest: doInitialRequest,
    }
  )

  return {
    productCollections: productCollections || [],
    fetchingProductCollections,
  }
}

export default useStoreProductCollections
